import { render, staticRenderFns } from "./ContentViews.vue?vue&type=template&id=0c001e0e&"
import script from "./ContentViews.vue?vue&type=script&lang=js&"
export * from "./ContentViews.vue?vue&type=script&lang=js&"
import style0 from "./ContentViews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c001e0e')) {
      api.createRecord('0c001e0e', component.options)
    } else {
      api.reload('0c001e0e', component.options)
    }
    module.hot.accept("./ContentViews.vue?vue&type=template&id=0c001e0e&", function () {
      api.rerender('0c001e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/ContentViews.vue"
export default component.exports